/**
 * @flow
 */
import * as React from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { observer } from 'mobx-react';

@observer
export default class NavBrand extends React.Component<void, void> {
  
  getLogoUrl(settings: any) {
    if(settings && settings.has('logo')) {
      const logo = settings.get('logo');
      if(logo.small && logo.small.url) {
        return logo.small.url;
      }
    }
    return null;
  }
  
  render () {
    const logoUrl = this.getLogoUrl(null);
    
    if(null === logoUrl) {
      return (
        <NavbarBrand href="/">KSSH - Analysen</NavbarBrand>
      )
    }
    return (
      <NavbarBrand href="/">
        <img src={logoUrl} alt=""/>
      </NavbarBrand>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Layout/Header/NavBrand.js